import { html, render } from "lit-html";
import Input from "../engine/input";
import { Commands } from "../engine/commands";

class CompleteScreen {
  constructor() {
    this.overlay = document.querySelector(".overlay");
    this.dialog = document.querySelector(".dialog");
  }

  handleClick(ev) {
    if (!this.dialog.contains(ev.target) || ev.target.matches(".button-ok")) {
      return Commands.QuitGame;
    }
  }

  handleInput(input) {
    if (input == Input.Cancel || input == Input.Ok) {
      return Commands.QuitGame;
    }
    return false;
  }

  rescale() {
    return;
  }

  activate(context) {
    this.overlay.classList.add("is-visible");
    this.dialog.classList.add("is-visible");
    this.dialog.classList.add("is-alert");
    render(this.getDialogTemplate(context.message), this.dialog);
  }

  deactivate(context) {
    this.overlay.classList.remove("is-visible");
    this.dialog.classList.remove("is-visible");
    this.dialog.classList.remove("is-alert");
  }

  getDialogTemplate(message) {
    return html`
      <div class="complete">
        <h2>Caldera</h2>
        <p>Class of PROD226, 2022</p>
        <p>Thanks for playing!</p>
      </div>
      <footer class="dialog-footer">
        <button class="button-ok">Ok</button>
      </footer>
    `;
  }

  render(stage) {
    return;
  }
}

export default CompleteScreen;
